import styled from 'styled-components';

export const DetailContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 480px;
    margin: 0 auto;
    border-radius: 16px;
    overflow: hidden;
`;

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

interface StyledBenefitProps {
    color: string; // User-defined color
    $redeemed?: boolean;
}

export const EllipseLeft = ({ color, $redeemed }: StyledBenefitProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="24" viewBox="0 0 12 24" fill="none">
        <defs>
            <linearGradient id="gradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="50%" stopColor={color} />
                <stop offset="49.99%" stopColor={$redeemed ? "currentColor" : color} />
            </linearGradient>
        </defs>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 0.75L0 0.75C6.62742 0.75 12 6.12258 12 12.75C12 19.3774 6.62742 24.75 0 24.75L12 24.75L12 12.75L12 0.75Z"
            fill="url(#gradient)"
        />
    </svg>
);

export const EllipseRight = ({ color, $redeemed }: StyledBenefitProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="24" viewBox="0 0 12 24" fill="none">
        <defs>
            <linearGradient id="gradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="50%" stopColor={color} />
                <stop offset="49.99%" stopColor={$redeemed ? "currentColor" : color} />
            </linearGradient>
        </defs>
        <path fillRule="evenodd" clipRule="evenodd" d="M0 24.75L12 24.75C5.37258 24.75 4.69686e-07 19.3774 1.04907e-06 12.75C1.62846e-06 6.12258 5.37259 0.749999 12 0.75L2.09815e-06 0.749999L1.04907e-06 12.75L0 24.75Z"
            fill="url(#gradient)"
        />
    </svg>
);

export const ImageContainerStyled = styled.div<{ $backgroundColor: string }>`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 480px;
    background-color: ${props => props.$backgroundColor};
    
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;

export const ImageStyled = styled.img`
    flex: 1 0 0;
    align-self: stretch;
`;

export const RedeemedMessage = styled.p`
    display:  flex;
    flex-flow: column;
    gap: 16px;
    justify-content: center;
    min-height: 256px;

    h3, p {
        text-align: center;
    }
    h3 {
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
    }
`;

export const DetailStyled = styled.div<{ $backgroundColor: string }>`
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 24px;
    background-color: ${props => props.$backgroundColor};
`;

export const Title = styled.h1`
    color: ${({ theme }) => theme?.colors?.text?.headings};
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: "Red Hat Display", sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%;
`;

export const Description = styled.p`
    color: ${({ theme }) => theme?.colors?.text?.paragraphs};
    font-family: "Red Hat Display", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
`;

export const ValidUntil = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    text-align: center;
    margin-top: 32px;

    span:first-child {
        color: ${({ theme }) => theme?.colors?.text?.headings};
        font-family: "Red Hat Display", sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 130%;
    }

    span:last-child {
        color: ${({ theme }) => theme?.colors?.text?.paragraphs};
        font-family: "Red Hat Display", sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 130%;
    }
`;

export const DividerStyled = styled.div<{ $backgroundColor: string }>`
    display: flex;
    height: 24px;
    justify-content: center;
    align-items: flex-start;
    color: ${({ theme }) => theme?.colors?.text?.muted};
`;

export const DashContainerStyled = styled.div<{ $backgroundColor: string, $redeemed?: boolean }>`
    width: calc(100% - 24px); 
    height: 24px;
    align-items: center;
    // background-color: ${props => props.$backgroundColor};
    background: ${({ theme, $redeemed, $backgroundColor }) =>
        $redeemed ?
            `linear-gradient(0deg, ${theme?.colors?.text?.muted} 49.99%, ${$backgroundColor} 50%)`
            :
            $backgroundColor};

`;

export const DashStyled = styled.div<{ $backgroundColor: string }>`
    height: 12px;
    align-self: stretch;
    border-bottom: 3px dashed ${({ theme }) => theme?.colors?.text?.muted};
    border-style: dashed;
    border-width: 0 0 3px 0;
    border-image: repeating-linear-gradient(
        to right,
        ${({ theme }) => theme?.colors?.text?.muted} 0,
        ${({ theme }) => theme?.colors?.text?.muted} 8px,
        transparent 8px,
        transparent 16px
    ) 1;
`;

export const ActionWrapper = styled.div<{ $backgroundColor: string, $redeemed?: boolean }>`
    width: 100%;
    background-color: ${({ theme, $redeemed, $backgroundColor }) => $redeemed ? theme?.colors?.text?.muted : $backgroundColor};
    padding: 24px;
    border-radius: 0 0 16px 16px;
    display: flex;
    justify-content: center;
    align-items: center;
`;